// Angular Files
import { Injectable } from '@angular/core';

// Other External Files
import { Observable } from 'rxjs';

// Angular Material Files
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

// Teller Online Files
import { CoreModule } from 'apps/admin-portal/src/app/core/core.module';
import { ConfirmDialogComponent, ConfirmDialogData } from 'apps/admin-portal/src/app/shared/components/confirm-dialog/confirm-dialog.component';

// Teller Online Library Files
import { TellerOnlineAppService } from 'teller-online-libraries/core';

export interface FeatureCanDeactivate {
    canDeactivate: (featurePrompt: { message: string, title: string }) => boolean | Observable<boolean>;
}

@Injectable({
    providedIn: CoreModule
})
export class PendingChangesGuardService {

    constructor(
        private dialog: MatDialog,
        private appService: TellerOnlineAppService
    ) { }

    async canDeactivate(featureComponent: FeatureCanDeactivate): Promise<boolean> {
        const featurePrompt = {
            message: 'You have unsaved changes. Do you want to discard them and leave this page?',
            title: 'Unsaved Changes'
        };

        if (featureComponent) {
            const featureDeactivate = featureComponent.canDeactivate(featurePrompt);
            let canDeactivate: boolean;

            // If there are no pending changes, just allow deactivation; else confirm first
            if (featureDeactivate === true) {
                canDeactivate = true;
            } else {
                // Turn off loading before we prompt or the prompt won't work
                this.appService.finishLoading();

                // Show confirmation dialog
                const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                    width: '400px',
                    data: {
                        title: featurePrompt.title,
                        message: featurePrompt.message,
                        confirmText: 'Leave Page',
                        cancelText: 'Stay',
                        confirmColor: 'warn'
                    } as ConfirmDialogData
                });

                canDeactivate = await dialogRef.afterClosed().toPromise();
            }

            // Turn loading back on if we're leaving
            if (canDeactivate) {
                this.appService.triggerLoading('Loading...');
            }

            return canDeactivate;
        }
        return true;
    }
}
